import { handleBorderProps } from '@interfaces';
import { useTheme } from '@mui/material';
import { rem } from '@utils';

export const customMargin = {
    bottom: {
        super: '1rem',
        extraBig: '0.4375rem',
        big: '0.4375rem',
        medium: '0.3125rem',
        small: '0.1875rem',
        tiny: '0.125rem',
    },
    right: {
        super: '0',
        extraBig: '0',
        big: '0',
        medium: '0',
        small: '0',
        tiny: '0',
    },
};

export const handleBorderWidth = {
    'none': '0rem',
    '1x': '0.0625rem',
    '2x': '0.125rem',
};

export const avatarSizes ={
    super: {
        width: 120,
        height: 120,
    },
    extraBig: {
        width: 98,
        height: 98,
    },
    big: {
        width: 70,
        height: 70,
    },
    medium: {
        width: 56,
        height: 56,
    },
    small: {
        width: 48,
        height: 48,
    },
    tiny: {
        width: 38,
        height: 38,
    },
};

export const fontSizeTitle = {
    super: '1.25rem',
    extraBig: '1rem',
    big: '1rem',
    medium: '.9375rem',
    small: '1rem',
    tiny: '.75rem',
};

export const fontSizeLegend = {
    super: '0.875rem',
    extraBig: '0.875rem',
    big: '0.75rem',
    medium: '0.75rem',
    small: '0.75rem',
    tiny: '0.625rem',
};

export const handleBorder = ({
    borderWidth, borderColor,
}: handleBorderProps) => {
    const { palette } = useTheme();

    return `${ borderWidth ?
        handleBorderWidth[borderWidth] : rem(1)}
        solid ${borderColor ? borderColor : palette.common.black}`;
};

export const sx = () => {
    const { palette } = useTheme();
    const css= {
        sxAvatarGroup: {
            default: {
                display: 'flex',
                alignItems: 'center',
            },
            right: {
                flexDirection: 'row',
            },
            bottom: {
                flexDirection: 'column',
            },
        },
        sxAvatarDefault: {
            backgroundColor: palette.secondaryColor,
            color: palette.common.white,
        },
        sxBoxAvatarInfo: {
            right: {
                marginLeft: rem(10),
                alignItems: 'start',
            },
            bottom: {
                alignItems: 'center',
            },
            default: {
                display: 'flex',
                flexDirection: 'column',
            },
        },

    };
    return { css };
};
